import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetSecurityStackViewDto from "./dto/get-security-stack-view.dto";
import type GetSecurityStackHeaderViewDto from "./dto/get-security-stack-header-view.dto";
import type UpdateSecurityStackHeaderViewDto from "./dto/update-security-stack-header-view.dto";

export const SecurityStackViewEffectActions = {
  getSecurityStackView: `${Entities.SecurityStackView}_getSecurityStackView`,
  getSecurityStackHeaderView: `${Entities.SecurityStackView}_getSecurityStackHeaderView`,
  updateSecurityStackHeaderView: `${Entities.SecurityStackView}_updateSecurityStackHeaderView`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.SecurityStackView,
  initSchema,
  aliasName: DIContainerKeys.SecurityStackViewService,
})
export class SecurityStackViewService extends HttpService {
  @loader(Loaders.GetSecurityStackViewLoader)
  @action(DIContainerKeys.SecurityStackViewService)
  public *getSecurityStackView(dto: GetSecurityStackViewDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetSecurityStackViewLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetSecurityStackView),
        params: {
          optionEnum1: 0,
          optionEnum99: 3,
        },
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetSecurityStackViewLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.SecurityStackView, dto.clientId, response);
    yield this.setLoaderState(Loaders.GetSecurityStackViewLoader, false);
  }

  @loader(Loaders.GetSecurityStackHeaderViewLoader)
  @action(DIContainerKeys.SecurityStackViewService)
  public *getSecurityStackHeaderView(dto: GetSecurityStackHeaderViewDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetSecurityStackHeaderView),
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.SecurityStackView, dto.clientId, response);
    yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, false);
  }

  @action(DIContainerKeys.SecurityStackViewService)
  public *updateSecurityStackHeaderView(dto: UpdateSecurityStackHeaderViewDto): any {
    const formData = this.toFormData(dto);
    const response = yield call(
      this.post,
      {
        url: BASE_API_PATHS.updateSecurityStackHeaderView,
        domain: API_DOMENS.CC_API,
        body: formData,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetUserDeviceIssuesLoader, false);
      return;
    } else {
      this.getSecurityStackHeaderView({ clientId: dto.SettingOwner })
    }
  }
}